export default {
    SET_WEEKLY_SENT_ORDERS_FILTERS: (state, filters) => {
        state.weeklySentOrdersFilters = filters
    },
    CLEAR_WEEKLY_SENT_ORDERS_FILTERS: state => {
        state.weeklySentOrdersFilters = state.setInitialWeeklySentOrdersFilters()
    },
    SET_MONTHLY_SENT_ORDERS_FILTERS: (state, filters) => {
        state.monthlySentOrdersFilters = filters
    },
    CLEAR_MONTHLY_SENT_ORDERS_FILTERS: state => {
        state.monthlySentOrdersFilters = state.setInitialMonthlySentOrdersFilters()
    },
    GET_PRODUCTS_SUCCESS: (state, data) => {
        state.products = data
    }
}